import { MachineDto } from "./machine.dto";

export class PauseReasonDto {
    id!: number;
    name!: string;
    isDefault!: boolean;
    timeStimated!: number;
    updatedById?:number;
    machines?: MachineDto[];
    _count?: {
        productionPauses?: number;
        machines?: number;
    };
}
